module.exports = __webpack_public_path__ + "media/1x1/gh-77872d15.svg";